import React, { useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import {
  closeInvitation,
  checkInvitationStatus,
  requestResponseInvitation,
} from "../redux/actions/confirmInvitationActionCreators";
import { useHistory } from "react-router-dom";

export default function ConfirmInvitationModal({ type }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();

  const { isAuth } = useSelector((state) => state.user);
  const openInvitation = useSelector(
    (state) => state.confirmInvitation.openConfirm
  );

  const invitationId = useSelector(
    (state) => state.confirmInvitation.enterpriseID
  );

  const status = useSelector((state) => state.confirmInvitation.status);

  const handleClose = () => {
    dispatch(closeInvitation());
  };

  useEffect(() => {
    if (openInvitation && isAuth) {
      dispatch(checkInvitationStatus(invitationId));
    }
  }, [openInvitation, isAuth]);

  const handleRefuseInvitation = () => {
    dispatch(
      requestResponseInvitation(invitationId, status?.enterprise, false)
    );
  };

  const handleAcceptInvitation = () => {
    dispatch(
      requestResponseInvitation(invitationId, status?.enterprise, true, history)
    );
  };

  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div>
      <Dialog
        open={openInvitation && isAuth}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "30%", padding: "20px" }
            : {
                width: "90%",
                height: "50%",
                margin: "5px 0",
                padding: "5px",
              },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <DialogTitle mb={1} align="center">
          <Typography variant="title1" sx={{ fontSize: "38px" }}>
            Invitation
          </Typography>
        </DialogTitle>
        {status?.canceled_invitation ? (
          <DialogContent sx={{ padding: "15px 10px" }}>
            <DialogContentText mb={2} align="center" id="link-orga">
              {t("invitation_refused")}
            </DialogContentText>
          </DialogContent>
        ) : (
          <DialogContent sx={{ padding: "15px 10px" }}>
            <DialogContentText mb={2} align="center" id="link-orga">
              {`${t("invitation_request1")} ${status?.first_name} ${
                status?.last_name
              }, ${t("the_administrator")} ${status?.enterprise} ${t(
                "invitation_request2"
              )}`}
            </DialogContentText>
            <DialogContentText mb={2} align="center" id="confirm-link-orga">
              {t("confirm_invit")}
            </DialogContentText>
          </DialogContent>
        )}
        {!status?.canceled_invitation && (
          <DialogActions sx={{ padding: "20px" }}>
            <Grid container spacing={5}>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="deleteButton"
                  onClick={handleRefuseInvitation}
                  fullWidth
                >
                  {t("refuse")}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="contained"
                  color="button"
                  onClick={handleAcceptInvitation}
                  fullWidth
                >
                  {t("accept")}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
